module.exports = __webpack_public_path__ + "static/img/61003.8d2efb6e.png";